export const tokenSchema = {
    id: '/token',
    properties: {
        name: {type: 'string'},
        symbol: {type: 'string'},
        decimals: {type: 'number'},
        address: {$ref: '/addressSchema'},
    },
    required: ['name', 'symbol', 'decimals', 'address'],
    type: 'object',
};



// WEBPACK FOOTER //
// ./~/0x.js/src/schemas/token_schema.ts